export const DELETE_CI_JOB_TYPE = 'DELETE_CI_JOB_TYPE';
export const ADD_EDIT_CI_JOB_TYPE = 'ADD_EDIT_CI_JOB_TYPE';
export const UPDATE_CI_JOB_TYPES_LIST = 'UPDATE_CI_JOB_TYPES_LIST';

export class CIJobTypeModel {
	id?: string;
	origin: string;
	productId: string;
	productName: string;
	formId: string;
	formName: string;
	isHybridProduct: boolean;
}